import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../config';
import { useNavigate } from 'react-router-dom';
import logo from './css/images.png';
import Lottie from 'lottie-react';
import loader from './css/loader.json';  // Path to your loader animation JSON file

const CompanyDetailPage = () => {
  const [companyDetails, setCompanyDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedCompany, setSelectedCompany] = useState(null);

  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const fromDate = queryParams.get('fromDate');
  const toDate = queryParams.get('toDate');
  const companyNameFromQuery = queryParams.get('companyName');
  const compCode = queryParams.get('compCode');

  useEffect(() => {
    async function fetchCompanyDetails() {
      try {
        const accessToken = localStorage.getItem('accessToken'); // Retrieve the token
        const userId = localStorage.getItem('userId'); // Retrieve the user ID
        const response = await fetch(`${API_BASE_URL}/api/company-details?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&compCode=${encodeURIComponent(compCode)}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`, // Include the token
            'UserId': userId ? userId : '', // Include the user ID
          }
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        if (data.length === 0) {
          setError('No data found for the specified date range');
        } else {
          setCompanyDetails(data);
          if (companyNameFromQuery) {
            const selected = data.find(c => c.Name === companyNameFromQuery);
            setSelectedCompany(selected);
          }
        }
      } catch (error) {
        console.error('Error fetching company details:', error);
        setError('Error fetching company details');
      } finally {
        setLoading(false);
      }
    }

    fetchCompanyDetails();
  }, [fromDate, toDate, companyNameFromQuery, compCode]);

  const handleCompanyClick = (company) => {
    localStorage.setItem('selectedCompany', JSON.stringify(company));
    localStorage.setItem('fromDate', fromDate);
    localStorage.setItem('toDate', toDate);
    localStorage.setItem('compCode', compCode);

    const storedCompanies = JSON.parse(localStorage.getItem('companyNames')) || [];
    if (!storedCompanies.includes(company.Name)) {
      storedCompanies.push(company.Name);
      localStorage.setItem('companyNames', JSON.stringify(storedCompanies));
    }

    navigate(`/dashboard?companyName=${encodeURIComponent(company.Name)}&fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&compCode=${encodeURIComponent(compCode)}`);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 p-4">
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
          <Lottie animationData={loader} loop={true} autoplay={true} style={{ height: 100, width: 100 }} />
        </div>
      )}

      <div className="w-full max-w-[600px]">
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border border-slate-100">
          <div className="flex justify-center mb-8">
            <img src={logo} alt="DeviSoft Logo" className="w-48 h-16 object-contain" />
          </div>

          <h1 className="text-2xl font-bold text-slate-800 mb-6 text-center">Select Company Branch</h1>

          {selectedCompany && (
            <div className="mb-6 p-4 bg-blue-50 rounded-xl border border-blue-100">
              <h2 className="text-lg font-bold text-blue-800 text-center">{selectedCompany.Name}</h2>
            </div>
          )}

          {error && (
            <div className="mb-6 p-3 rounded-lg bg-red-50 border border-red-100 text-red-600 text-sm">
              {error}
            </div>
          )}

          <div className="overflow-hidden rounded-xl border border-slate-200 shadow-sm">
            {companyDetails.length === 0 && !loading ? (
              <div className="px-6 py-12 text-center text-slate-500 italic bg-slate-50">
                No data found for the selected date range.
              </div>
            ) : (
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-slate-100 border-b border-slate-200">
                    <th className="px-6 py-4 text-sm font-bold text-slate-700 uppercase tracking-wider">
                      Branch Name
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {companyDetails.map((company, index) => (
                    <tr
                      key={index}
                      className="hover:bg-blue-50 transition-colors cursor-pointer group"
                      onClick={() => handleCompanyClick(company)}
                    >
                      <td className="px-6 py-4 border-r border-slate-100 last:border-r-0">
                        <span className="text-blue-600 font-semibold group-hover:text-blue-700 transition-colors">
                          {company.Name}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        <p className="text-center mt-8 text-slate-500 text-sm">
          &copy; {new Date().getFullYear()} DeviSoft. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default CompanyDetailPage;
